import 'bootstrap/dist/css/bootstrap.min.css';
import './sass/App.scss';

import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Overview from './components/Overview';
import Analysis from './components/Analysis';
import Premium from './components/Premium';
import FloorPlan from './components/FloorPlan';
import GenericNotFound from './components/GenericNotFound';

const WrappedLayout = ({ pathname }) => {
    let fragment = null;

    switch (pathname) {
        case '/overview':
            fragment = <Overview />;
            break;
        case '/analysis':
            fragment = <Analysis />;
            break;
        case '/premium':
            fragment = <Premium />;
            break;
        case '/floor-plan':
            fragment = <FloorPlan />;
            break;
        default:
            fragment = <Home />;
    }

    return (
        <div>
            {fragment}
            <Footer />
        </div>
    );
};

const AnimatedSwitch = () => {
    const location = useLocation();

    return (
        <TransitionGroup component={null}>
            <CSSTransition key={location.pathname} classNames="fade" timeout={400} onEnter={() => window.scrollTo(0, 0)}>
                <Routes location={location}>
                    <Route path="/">
                        <Route index element={<WrappedLayout pathname={location.pathname} />} />
                        <Route path="overview" element={<WrappedLayout pathname={location.pathname} />} />
                        <Route path="analysis" element={<WrappedLayout pathname={location.pathname} />} />
                        <Route path="premium" element={<WrappedLayout pathname={location.pathname} />} />
                        <Route path="floor-plan" element={<WrappedLayout pathname={location.pathname} />} />
                        <Route path="*" element={<GenericNotFound />} />
                    </Route>
                </Routes>
            </CSSTransition>
        </TransitionGroup>
    );
};

const TITLES = {
    '/overview': '사업개요 - HIGHCUBE',
    '/analysis': '입지분석 - HIGHCUBE',
    '/premium': '프리미엄 - HIGHCUBE',
    '/floor-plan': '층별안내 - HIGHCUBE',
    default: 'HIGHCUBE',
};
const App = () => {
    const location = useLocation();

    useEffect(() => {
        document.title = TITLES.hasOwnProperty(location.pathname) ? TITLES[location.pathname] : TITLES.default;
    }, [location]);

    return (
        <React.Fragment>
            <Header />
            <AnimatedSwitch />
        </React.Fragment>
    );
};

export default App;
